export default "__VITE_ASSET__dad5ab6d__"